/**
 * 打开表格列设置弹窗
 * @param {Object} refTable el-table 组件的 ref
 * @param {String} tableColumnRefName TableColumnSettingDialog 组件的 ref 名称
 */
export function openTableColumnSettingDialog(refTable, tableColumnRefName = 'tableColumnSettingDialog') {
  const ref = this.$refs[tableColumnRefName]
  if (!ref) {
    throw new Error('tableColumnSettingDialog ref is not found')
  }
  ref.open(refTable)
}

export const openNewWindow = (router, params) => {
  let routeData = router.resolve(params);
  window.open(routeData.href, '_blank');
}

export const printHtml =(htmlStr, cssPaths = []) => {
  const iframe = document.createElement('iframe');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;

  // 拼接外部样式链接
  const cssLinks = cssPaths
    .map(path => `<link rel="stylesheet" href="${path}">`)
    .join('\n');

  doc.open();
  doc.write(`
    <html>
      <head>
        <title>打印</title>
        ${cssLinks}
        <style>
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          @page {
            size: A4;
            margin: 5mm;
          }
          @media print {
            body {
              margin: 0mm !important;
            }
          }
        </style>
      </head>
      <body>
        ${htmlStr}
      </body>
    </html>
  `);
  doc.close();

  // 等待 CSS 加载完毕后再 print，避免样式缺失
  const handlePrint = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };

  // 检测资源加载
  if (cssPaths.length > 0) {
    const links = doc.querySelectorAll('link');
    let loaded = 0;

    links.forEach(link => {
      link.onload = () => {
        loaded++;
        if (loaded === links.length) {
          handlePrint();
        }
      };
      link.onerror = () => {
        // 失败也继续计算，避免一直不打印
        loaded++;
        if (loaded === links.length) {
          handlePrint();
        } 
      };
    });
  } else {
    // 没有 CSS 直接打印
    handlePrint();
  }
}

export function printImageWithIframe(imgUrl) {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  // 写入打印页面的 HTML 和 CSS 样式
  doc.write(`
    <html>
      <head>
        <title>图片打印</title>
        <style>
          body { margin: 0; }
          img { max-width: 100%; display: block; margin: 0 auto; }
          /* 打印时强制分页 */
          .page-break { page-break-after: always; }
        </style>
      </head>
      <body>
        <img src="${imgUrl}" onload="window.print(); window.close();" />
        <div class="page-break"></div>
      </body>
    </html>
  `);
  doc.close();
  
  // 打印完成后移除 iframe
  iframe.onload = function() {
    setTimeout(() => document.body.removeChild(iframe), 500);
  };
}